const collections = {
    PARENT_TYPE : "PARENT_TYPE",
    IDENTIFICATION_TYPE : "IDENTIFICATION_TYPE",
    SEX : "SEX",
    JOB_TYPE : "JOB_TYPE"
}

export default {
    collections
};